import React from 'react'
import { WhiteSpace } from 'antd-mobile'
import Article from './article'
import Comment from './comment'

export default props => {
  return (
    <div style={{
      background: '#F5F6F8',
    }}>
      <Article isShare={false} {...props} />
      <Comment isShare={false} {...props} />
      <WhiteSpace size="xl" />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/modules/knowledge/components/index.js